import { useQuery } from "@tanstack/react-query";
import { fetchRouteEstimate } from "@/services/googleDirectionsService";
import { toLocationFullAddress } from "@/utils/places/normalizeGooglePlace";
import type { DailyCommuteLocation } from "@/types/dailyCommuteLocation";

function routeEstimateKey(
  from: DailyCommuteLocation | null,
  to: DailyCommuteLocation | null
): string | null {
  const fromLabel = from ? toLocationFullAddress(from) : "";
  const toLabel = to ? toLocationFullAddress(to) : "";
  if (!fromLabel || !toLabel) return null;

  return [
    from.placeId || fromLabel,
    from.lat,
    from.lng,
    to.placeId || toLabel,
    to.lat,
    to.lng,
  ].join("|");
}

export function useRouteEstimate(
  from: DailyCommuteLocation | null,
  to: DailyCommuteLocation | null,
  enabled = true
) {
  const cacheKey = routeEstimateKey(from, to);

  return useQuery({
    queryKey: ["route-estimate", cacheKey],
    queryFn: () => fetchRouteEstimate(from!, to!),
    enabled: enabled && !!cacheKey,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
}
